import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { userAuthApis, } from './services/userLogin';
import { datalyzeProblemApis } from './services/datalyzeProblems';
import userSlice, { cleanedDatasetsReducer, completedChartsReducer, rawDatasetsReducer } from './slices';

// IndexedDB persistence has been removed
// Cleaned datasets and completed charts are now stored in Redux state only (in-memory)

export const store = configureStore({
    reducer: {
        user: userSlice, // Add your custom reducers
        cleanedDatasets: cleanedDatasetsReducer, // Non-persisted cleaned datasets (in-memory only)
        completedCharts: completedChartsReducer, // Non-persisted completed charts (in-memory only)
        rawDatasets: rawDatasetsReducer, // Non-persisted raw datasets (prefetched from CloudFront)
        [userAuthApis.reducerPath]: userAuthApis.reducer, // Add RTK Query reducer
        [datalyzeProblemApis.reducerPath]: datalyzeProblemApis.reducer, // Add RTK Query reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: false, // Disable immutable state check to avoid performance warnings
        }).concat(userAuthApis.middleware).concat(datalyzeProblemApis.middleware), // Add RTK Query middleware
});

// Set up listeners for automatic cache invalidation and refetching
setupListeners(store.dispatch);
